var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubeDepartmentVectorDashed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 22,
    viewBox: "0 0 13 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 5",
    d: "M1 19H0.5V19.5H1V19ZM7.33333 19C7.33333 20.4728 8.52724 21.6667 10 21.6667C11.4728 21.6667 12.6667 20.4728 12.6667 19C12.6667 17.5272 11.4728 16.3333 10 16.3333C8.52724 16.3333 7.33333 17.5272 7.33333 19ZM0.5 0V0.95H1.5V0H0.5ZM0.5 2.85V4.75H1.5V2.85H0.5ZM0.5 6.65V8.55H1.5V6.65H0.5ZM0.5 10.45V12.35H1.5V10.45H0.5ZM0.5 14.25V16.15H1.5V14.25H0.5ZM0.5 18.05V19H1.5V18.05H0.5ZM1 19.5H2.125V18.5H1V19.5ZM4.375 19.5H6.625V18.5H4.375V19.5ZM8.875 19.5H10V18.5H8.875V19.5Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubeDepartmentVectorDashed);
export default __webpack_public_path__ + "static/media/subeDepartmentVectorDashed.33dd48cb7021b2737cd81b58fa5b676b.svg";
export { ForwardRef as ReactComponent };